import { RootState } from 'store';

export function getPartnerSelector({ partner }: RootState) {
  return partner.data;
}